import { useState, useEffect } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { getDocument } from '@/lib/firebase/firestore';

export function useAdminCheck() {
  const { user, profile, loading: authLoading } = useAuth();
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkAdminStatus = async () => {
      if (!user) {
        setIsAdmin(false);
        setLoading(false);
        return;
      }

      // First check if profile already has this info (optimization)
      if (profile && 'role' in profile) {
        setIsAdmin(profile.role === 'admin');
        setLoading(false);
        return;
      }

      try {
        // Fetch user document to check for role
        const userDoc = await getDocument<any>('users', user.uid);
        if (userDoc && userDoc.role === 'admin') {
          setIsAdmin(true);
        } else {
          setIsAdmin(false);
        }
      } catch (error) {
        console.error('Error checking admin status:', error);
        setIsAdmin(false);
      } finally {
        setLoading(false);
      }
    };

    if (!authLoading) {
      checkAdminStatus();
    }
  }, [user, profile, authLoading]);

  return { isAdmin, loading: loading || authLoading };
}
